import React, { useRef } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction } from "@util/utils";

/**
 * 編輯備註彈窗
 * @param {Object} props - 組件屬性
 * @param {boolean} props.open - 是否開啟彈窗
 * @param {Object} props.sourceData - 來源資料
 * @param {Object} props.sourceData.item - 目前編輯備註的品項資料
 * @param {Function} props.refresh - 刷新備註的回調函數
 * @param {Function} props.onClose - 關閉彈窗的回調函數
 */
const EditMemoDialog = ({ open, sourceData, refresh: updateNotes, onClose }) => {
	const { itemData } = sourceData || {};
	const memoRef = useRef(null);

	const handleClickSave = () => {
		let newMemo = memoRef.current && memoRef.current.getResult();
		isFunction(updateNotes) && updateNotes(itemData, newMemo);
		isFunction(onClose) && onClose();
	};

	if (!open) return null;

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-65rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>{"編輯備註"}</GradientColorHeader>
			<DialogContent>
				<TextField label="品項備註" key={itemData?.notes} defaultValue={itemData?.notes ?? ""} ref={memoRef} minRows={2} inputProps={{ placeholder: "請輸入" }} fullWidth multiline />
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleClickSave}>
					儲存
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditMemoDialog;
